/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getPharmacists } from 'app/entities/pharmacist/pharmacist.reducer';
import { getEntities as getDiaglabAssistants } from 'app/entities/diaglab-assistant/diaglab-assistant.reducer';
import { getEntities as getHospitalAssistants } from 'app/entities/hospital-assistant/hospital-assistant.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { createEntity, getEntity, reset, updateEntity } from './patient-name.reducer';

export const PatientNameUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const doctors = useAppSelector(state => state.doctor.entities);
  const pharmacists = useAppSelector(state => state.pharmacist.entities);
  const diaglabAssistants = useAppSelector(state => state.diaglabAssistant.entities);
  const hospitalAssistants = useAppSelector(state => state.hospitalAssistant.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const patientNameEntity = useAppSelector(state => state.patientName.entity);
  const loading = useAppSelector(state => state.patientName.loading);
  const updating = useAppSelector(state => state.patientName.updating);
  const updateSuccess = useAppSelector(state => state.patientName.updateSuccess);

  const handleClose = () => {
    navigate(`/patient-name${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDoctors({}));
    dispatch(getPharmacists({}));
    dispatch(getDiaglabAssistants({}));
    dispatch(getHospitalAssistants({}));
    dispatch(getGlucoUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.created = convertDateTimeToServer(values.created);
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.totalReading !== undefined && typeof values.totalReading !== 'number') {
      values.totalReading = Number(values.totalReading);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...patientNameEntity,
      ...values,
      doctor: doctors.find(it => it.id.toString() === values.doctor?.toString()),
      pharmacist: pharmacists.find(it => it.id.toString() === values.pharmacist?.toString()),
      diaglabAssistant: diaglabAssistants.find(it => it.id.toString() === values.diaglabAssistant?.toString()),
      hospitalAssistant: hospitalAssistants.find(it => it.id.toString() === values.hospitalAssistant?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          created: displayDefaultDateTime(),
        }
      : {
          ...patientNameEntity,
          created: convertDateTimeFromServer(patientNameEntity.created),
          doctor: patientNameEntity?.doctor?.id,
          pharmacist: patientNameEntity?.pharmacist?.id,
          diaglabAssistant: patientNameEntity?.diaglabAssistant?.id,
          hospitalAssistant: patientNameEntity?.hospitalAssistant?.id,
          patient: patientNameEntity?.patient?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.patientName.home.createOrEditLabel" data-cy="PatientNameCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.patientName.home.createOrEditLabel">Create or edit a PatientName</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="patient-name-id"
                  label={translate('tinyMedicRestApp.patientName.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.patientName.preferred')}
                id="patient-name-preferred"
                name="preferred"
                data-cy="preferred"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientName.givenName')}
                id="patient-name-givenName"
                name="givenName"
                data-cy="givenName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientName.prefix')}
                id="patient-name-prefix"
                name="prefix"
                data-cy="prefix"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientName.middleName')}
                id="patient-name-middleName"
                name="middleName"
                data-cy="middleName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientName.familyNamePrefix')}
                id="patient-name-familyNamePrefix"
                name="familyNamePrefix"
                data-cy="familyNamePrefix"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientName.familyName')}
                id="patient-name-familyName"
                name="familyName"
                data-cy="familyName"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientName.familyNameSufix')}
                id="patient-name-familyNameSufix"
                name="familyNameSufix"
                data-cy="familyNameSufix"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientName.familyName2')}
                id="patient-name-familyName2"
                name="familyName2"
                data-cy="familyName2"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientName.active')}
                id="patient-name-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientName.created')}
                id="patient-name-created"
                name="created"
                data-cy="created"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientName.microSec')}
                id="patient-name-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientName.timestampentry')}
                id="patient-name-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientName.totalReading')}
                id="patient-name-totalReading"
                name="totalReading"
                data-cy="totalReading"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientName.lastupdated')}
                id="patient-name-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientName.cursor')}
                id="patient-name-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientName.uuid')}
                id="patient-name-uuid"
                name="uuid"
                data-cy="uuid"
                type="text"
              />
              <ValidatedField
                id="patient-name-doctor"
                name="doctor"
                data-cy="doctor"
                label={translate('tinyMedicRestApp.patientName.doctor')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-name-pharmacist"
                name="pharmacist"
                data-cy="pharmacist"
                label={translate('tinyMedicRestApp.patientName.pharmacist')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacists
                  ? pharmacists.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-name-diaglabAssistant"
                name="diaglabAssistant"
                data-cy="diaglabAssistant"
                label={translate('tinyMedicRestApp.patientName.diaglabAssistant')}
                type="select"
              >
                <option value="" key="0" />
                {diaglabAssistants
                  ? diaglabAssistants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-name-hospitalAssistant"
                name="hospitalAssistant"
                data-cy="hospitalAssistant"
                label={translate('tinyMedicRestApp.patientName.hospitalAssistant')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalAssistants
                  ? hospitalAssistants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-name-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.patientName.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/patient-name" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PatientNameUpdate;
